module.exports = __webpack_public_path__ + "img/xnxlc-3-sm.0927f532.jpg";